import React, { useEffect, useState } from "react";
import http from "../../../src/Redux/services/http-common.jsx";
import { toast } from "react-toastify";

function MembershipStatus({ patientId, cartId, medicineCart, fetchCartList,isMembershipApplied,type }) {
  const [hasMembership, setHasMembership] = useState(null);
  const [membershipCode, setMembershipCode] = useState(null);


  useEffect(() => {
    const fetchMembershipStatus = async () => {
      try {
        const response = await http.get(
          `${process.env.REACT_APP_PROMO}membership/membership/for-patient?patientId=${patientId}`
        
        );

        if (response.status === 200) {
          const rawData = response?.data?.data ?? response?.data;

          if (Array.isArray(rawData) && rawData.length > 0) {
            const activeMembership =
              rawData.find((item) => item?.status === "ACTIVE") ?? rawData[0];

            if (activeMembership?.membershipCode) {
              setHasMembership(true);
              setMembershipCode(activeMembership.membershipCode);
              return;
            }
          }

          if (rawData && !Array.isArray(rawData)) {
            const membershipRecord =
              rawData?.status === "ACTIVE" ? rawData : null;

            if (membershipRecord?.membershipCode) {
              setHasMembership(true);
              setMembershipCode(membershipRecord.membershipCode);
              return;
            }
          }
        }

        setHasMembership(false);
      } catch (error) {
        console.error("Error fetching membership status:", error);
        setHasMembership(false);
      }
    };

    fetchMembershipStatus();
  }, [patientId]);

  const handleAvailMembership = async () => {
    if (!cartId) {
      toast.error("Cart not available. Please refresh and try again.", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    const payload = {
      cartId,
      cartType: type === "lab" ? "LAB" : "MED",
      serviceType: "MMBR",
      membershipApplied: "Y",
      ...(membershipCode ? { membershipCode } : {}),
    };

    try {
      const response = await http.post(
        `${process.env.REACT_APP_CARTURL}/cart/benefits/apply-benefits`,
        payload
      );

      if (response?.status === 200 || response?.data?.status === "OK") {
        toast.success("Membership availed successfully!", {
          position: "top-center",
          autoClose: 3000,
        });
        fetchCartList();
      } else {
        toast.error("Failed to avail membership.", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error availing membership:", error);
      toast.error("Unable to apply membership benefits.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  const removeDiscount = async () => {
    if (!cartId) {
      toast.error("Cart not available. Please refresh and try again.", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    const payload = {
      cartId,
      cartType: type === "lab" ? "LAB" : "MED",
      serviceType: "MMBR",
      isCureCoinApplied: "N",
    };

    try {
      const response = await http.post(
        `${process.env.REACT_APP_CARTURL}/cart/benefits/remove-benefits`,
        payload
      );

      if (response?.status === 200 || response?.data?.status === "OK") {
        toast.success("Membership discount removed successfully.", {
          position: "top-center",
          autoClose: 3000,
        });
        fetchCartList();
      } else {
        toast.error("Failed to remove membership discount.", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error removing discount:", error);
      toast.error("Unable to remove membership discount.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "10px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: hasMembership ? "#e6f7e6" : "#fbe9e9",
        color: hasMembership ? "#155724" : "#721c24",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      {hasMembership ? (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <input
            type="checkbox"
            checked={isMembershipApplied}
            onChange={(e) => {
                if (e.target.checked) {
                  handleAvailMembership();
                } else {
                  removeDiscount();
                }
              }}
            //onChange={handleAvailMembership}
            style={{
              width: "20px",
              height: "20px",
              marginRight: "10px",
              accentColor: "#28a745",
              cursor: "pointer",
            }}
          />
          <span>Avail Membership</span>
        </div>
      ) : (
        <label
          style={{
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Membership Status: Membership Not Available
        </label>
      )}
    </div>
  );
}

export default MembershipStatus;
